export default __webpack_public_path__ + "static/media/background.65cca111.jpg";